<template>
  <div class="message-box" v-show="popShow">{{ msg }}</div>
</template>

<script>
export default {
  name: "message",
  props: ["message", "showTip"],
  data() {
    return {
      popShow: false
    };
  },
  created() {
    this.msg = this.message;
    this.popShow = this.showTip;
  },
  watch: {
    showTip(v) {
      this.popShow = v;
      if (this.popShow) {
        setTimeout(() => {
          this.popShow = false;
          this.$emit("hideTip", this.popShow);
        }, 2000);
      }
    },
    message(v) {
      this.msg = v;
    }
  }
};
</script>

<style lang="less" scoped>
.message-box {
  position: fixed;
  top: 15%;
  left: 50%;
  padding: 20px 40px;
  font-size: 14px;
  line-height: 14px;
  text-align: center;
  transform: translate3d(-50%, -50%, 0);
  border-radius: 5px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 900;
}
</style>
